/** @jsx isolateComponent */

import { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { useRouter } from 'next/router';

import { isolateComponent } from '@zapier/common-utils';
import { readCookie } from '@zapier/cookies';
import { GlobalStylesProvider, REBRAND_COOKIE } from '@zapier/design-system';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { UniversalLayout } from '@zapier/universal-layout';

type UniversalLayoutProps = React.ComponentProps<typeof UniversalLayout>;
type Props = Pick<
  Partial<UniversalLayoutProps>,
  | 'children'
  | 'mainContentId'
  | 'renderFooter'
  | 'renderHeader'
  | 'renderNotifications'
  | 'shouldRenderAlphabetNav'
  | 'shouldRenderSeoLinks'
>;

export const SsrUniversalLayout = (props: Props) => {
  const currentUrl = useRouter()?.pathname || '';
  const { trackEvent } = useTrackingContext();

  const [isRebrand, setIsRebrand] = useState<boolean>(false);
  useEffect(() => {
    const hasRebrandCookie = readCookie(REBRAND_COOKIE) === 'true';
    setIsRebrand(hasRebrandCookie);
  }, []);

  return (
    <GlobalStylesProvider isRebrand={isRebrand}>
      <UniversalLayout
        currentUrl={currentUrl}
        mainContentId={props.mainContentId}
        renderFooter={props.renderFooter}
        renderHeader={props.renderHeader}
        renderNotifications={props.renderNotifications}
        shouldRenderAlphabetNav={props.shouldRenderAlphabetNav}
        shouldRenderSeoLinks={props.shouldRenderSeoLinks}
        trackEvent={trackEvent}
        useMutation={useMutation}
        useQuery={useQuery}
      >
        {props.children}
      </UniversalLayout>
    </GlobalStylesProvider>
  );
};
